import React from 'react'
import styled, { css } from 'styled-components'

const BaseNav = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 27.5C21.4558 27.5 27.5 21.4558 27.5 14C27.5 6.54416 21.4558 0.5 14 0.5C6.54416 0.5 0.5 6.54416 0.5 14C0.5 21.4558 6.54416 27.5 14 27.5Z"
      fill="#EEEEEE"
      stroke="#000264"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.413 7L11 8.414L16.657 14.07L11 19.728L12.414 21.142L19.485 14.07L18.071 12.656L12.415 7H12.413Z"
      fill="#000064"
    />
  </svg>
)

export const Nav = styled(BaseNav)`
  ${({ flip }: { flip?: boolean }) =>
    flip &&
    css`
      transform: rotate(180deg);
    `}
`
